﻿import { getDB } from '@database';
import { resetAllStores } from '@store/createAppStore';
import { logout } from '@store/logout/services';
import { setModalStore } from '@store/modals/store';

export const LogUserOut = async () => {
  resetAllStores();
  setModalStore({
    modalIds: [],
  });
  window.localStorage.clear();
  window.sessionStorage.clear();
  getDB()?.tables.forEach((table) => table.clear());
  await logout();
};
